import type { CompetitionsPageEndpointResponse } from '@ps/isp-web-services-types';

import type { WidgetEffectParams } from '@swf/core/store';
import { authChange, pageChange } from '@swf/core/utils/actions';
import type { BasicSportsWidgetConfig } from '@swf/sports/pages/types';
import buildSportsRequest from '@swf/sports/utils/buildSportsRequest';
import getErrorCode from '@swf/sports/utils/getErrorCode';
import { getWidgetCancellationSignal } from '@swf/sports/utils/getWidgetCancellationSignal';
import { hasRequestAborted } from '@swf/sports/utils/hasRequestAborted';

import type { WidgetDispatch, WidgetSelect } from './types';

export const effects = {
  async preload(_payload: undefined, params: WidgetEffectParams<BasicSportsWidgetConfig>) {
    const { dispatch, widget, select, rootState } = params;

    const widgetSelect: WidgetSelect = select[widget.uid];
    const widgetDispatch: WidgetDispatch = dispatch[widget.uid];

    const { competitionsRequested, clear }: WidgetDispatch = widgetDispatch;

    authChange(params.actions)?.subscribe({
      next: () => competitionsRequested(),
      complete: () => clear()
    });

    pageChange(params.actions)?.subscribe({
      next: () => competitionsRequested(),
      complete: () => clear()
    });

    if (!widgetSelect.hasPreloaded(rootState)) {
      await competitionsRequested();
    }
  },
  async competitionsRequested(
    _payload: undefined,
    params: WidgetEffectParams<BasicSportsWidgetConfig>
  ): Promise<void> {
    const { dispatch, request, widget, select, rootState } = params;
    const { eventTypeId } = select.sports.getUrlParams(rootState);
    const widgetDispatch: WidgetDispatch = dispatch[widget.uid];
    const sportsRequest = buildSportsRequest(request, rootState);

    try {
      const { body } = await sportsRequest<CompetitionsPageEndpointResponse>({
        path: `/competitions-page/${eventTypeId}`,
        signal: getWidgetCancellationSignal(params)
      });

      widgetDispatch.dataLoadSuccess(body);
    } catch (error) {
      if (hasRequestAborted(error)) return;
      widgetDispatch.dataLoadFailed(getErrorCode(error));
    }
  }
};
